









































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import moment from "vue-moment";
import _ from "lodash";
import SerialInfo from "../../store/entities/products/serial-info";
@Component
export default class ViewSerialsPaging extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) title: String;
  @Prop({ type: Object, default: new SerialInfo() }) serialInfo: SerialInfo;

  serialList = [];
  serialPageList = [];
  totalCount = 0;
  currentPage = 1;
  pageSize = 10;
  loading = false;
  keyword = "";
  cancel() {
    this.reset();
    this.$emit("input", false);
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.serialList = this.serialInfo.serials;
      await this.getLinePage();
    }
  }
  reset() {
    this.serialList = [];
    this.serialPageList = [];
    this.totalCount = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.loading = false;
    this.keyword = "";
  }
  get list() {
    var re = this.serialPageList;
    var startIndex = (this.lineCurrentPage - 1) * this.linePageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  get lineLoading() {
    return this.loading;
  }
  get linePageSize() {
    return this.pageSize;
  }
  get lineTotalCount() {
    return this.totalCount;
  }
  get lineCurrentPage() {
    return this.currentPage;
  }
  refreshLinePageIndex() {
    this.currentPage = 1;
  }
  linePageChange(page: number) {
    this.currentPage = page;
    this.getLinePage();
  }
  linePageSizeChange(pagesize: number) {
    this.pageSize = pagesize;
    this.getLinePage();
  }
  async searchData() {
    this.refreshLinePageIndex();
    await this.getLinePage();
  }
  async getLinePage() {
    var list = this.serialList;
    if (!_.isNil(this.keyword) && !_.isEmpty(this.keyword)) {
      var _keyWord = this.keyword.toUpperCase();
      list = _.filter(this.serialList, function(o) {
        return o.serialNo.toUpperCase().indexOf(_keyWord) >= 0;
      });
    }
    this.totalCount = _.isNil(list) ? 0 : list.length;

    this.serialPageList = Util.pagingItems(
      list,
      this.pageSize,
      this.currentPage
    );
  }

  created() {}
  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 50,
    },
    {
      title: Util.L("Serial"),
      key: "serialNo",
    },
  ];
}
